import { render } from "./productPriceStrategyList.vue?vue&type=template&id=7fe6bafa&scoped=true"
import script from "./productPriceStrategyList.vue?vue&type=script&lang=js"
export * from "./productPriceStrategyList.vue?vue&type=script&lang=js"

import "./productPriceStrategyList.vue?vue&type=style&index=0&id=7fe6bafa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe6bafa"],['__file',"src/views/product/components/productPriceStrategyList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fe6bafa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fe6bafa', __exports__)) {
    api.reload('7fe6bafa', __exports__)
  }
  
  module.hot.accept("./productPriceStrategyList.vue?vue&type=template&id=7fe6bafa&scoped=true", () => {
    api.rerender('7fe6bafa', render)
  })

}


export default __exports__